import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-loans-quotation',
  templateUrl: './loans-quotation.component.html',
  styleUrls: ['./loans-quotation.component.scss']
})
export class LoansQuotationComponent implements OnInit {

  quotationForm: FormGroup;

  amortizationValues = {
    totalPaid: 0,
    totalInterest: 0
  }

  otherValues = {
    cantidad: 0,
    cantidadPagoMensual: 0,
    tasaInteresAnual: 0
  }

  amortization: any;
  editData: any;
  prestamoInicio: any;

  constructor(private formBuilder: FormBuilder, private authService: AuthenticationService, private route: ActivatedRoute, private router: Router, private datePipe: DatePipe) {
    this.route.queryParams.subscribe(() => {
    
      if (this.router.getCurrentNavigation()!.extras.state) {
        let data:any = this.router.getCurrentNavigation()!.extras.state;
        this.editData = data.quoteData;
        console.log(this.editData);
      }
    });
   }

  ngOnInit(): void {
    this.quotationForm = this.formBuilder.group({
      prestamoInicio: ["",[Validators.required]],
      cantidad: [null,[Validators.required]],
      tasaInteresAnual: [null,[Validators.required]],
      termino: [null,[Validators.required]],
      firstPayment:["",[Validators.required]],
      loanType:["",[Validators.required]]
    })

    let dataStore = this.authService.getLoanDataStore();

    if(this.editData) this.setEditData();
    else if(dataStore){
      this.quotationForm.patchValue(JSON.parse(dataStore));
      this.getAmortization();
    }
  }

  setEditData(){
    this.quotationForm.patchValue({
      prestamoInicio: this.editData?.prestamoInicio?.split('T')[0],
      cantidad: this.editData.cantidad,
      tasaInteresAnual: this.editData?.tasaInteresAnual,
      termino: this.editData?.termino
    });
    this.checkFields();
  }

  checkFields(){
    if (!this.quotationForm.invalid) {
      this.getAmortization();
    }
  }

  getAmortization(){
    let data = this.quotationForm.getRawValue();
    // data.terms = parseInt(data.terms);
    // console.log(data.loanDate);
    // data.loanDate = data.loanDate + "T12:00:00";
    let firstPayment = data.firstPayment;
    let date = new Date(firstPayment);
    date.setMonth(date.getMonth() - 1);
    date.setDate(date.getDate() + 1);
    data.prestamoInicio = date;
    console.log(data);
    this.authService.getAmortization(data).then((res:any)=>{
      console.log(res);
      this.amortization = res;
      this.otherValues = {
        cantidad:  data.cantidad,
        cantidadPagoMensual: res[0].thisPaymentAmount,
        tasaInteresAnual: data.tasaInteresAnual
      }
      // this.amortizationValues.totalPaid = res.reduce(function (acc = 0, obj:any) { return acc + obj.thisPaymentAmount }, 0);
      
      this.amortizationValues.totalInterest = res.reduce(function (acc = 0, obj:any) { return acc + obj.thisPaidToInterest }, 0);
      this.amortizationValues.totalPaid = this.amortizationValues.totalInterest +  data.cantidad;
      
    }, err=>{
      console.log(err);
    })
  }

  emptyDataStore(){
    this.authService.emptyLoanDataStore();
    location.reload();
  }

  createContract(): void {
    let data = this.quotationForm.getRawValue();
    let dateInicio = new Date(data.prestamoInicio)
    // dateInicio.setHours(dateInicio.getHours() - 4);
    let firstPayment = new Date(data.firstPayment);
    let diaDepago = new Date(data.firstPayment);
    firstPayment.setHours(firstPayment.getHours() + 24);
    data.prestamoCulminacion = this.datePipe.transform(new Date(firstPayment.setMonth(firstPayment.getMonth()+data.termino)),'yyyy-MM-dd') + "T00:00:00";
    // data.prestamoInicio += "T00:00:00";
    // data.prestamoInicio = new Date(new Date().toString().split('GMT')[0]+' UTC').toISOString();
    data.prestamoInicio = dateInicio.toISOString();
    data.amortization = this.amortization;
    data.totalDePagos = this.amortizationValues.totalPaid;
    data.cantidadPagoMensual = this.amortization[0].thisPaymentAmount;
    data.cargoFinanciamiento = this.amortizationValues.totalInterest;
    data.diaDePago = diaDepago.getUTCDate();

    let dataStore = JSON.stringify(this.quotationForm.getRawValue());
    this.authService.loanDataStore(dataStore);
    console.log(data);
    let navigationExtras: NavigationExtras = {
      state: {
        quoteData: data,
        editData: this.editData
      }
    };
    this.router.navigate(["/loans/create-contract"], navigationExtras);
  }

}
